/**
 * Servicio para obtener imágenes de recetas
 * 
 * ESTRUCTURA SIMPLE:
 * Cada categoría tiene un array de URLs de fotos.
 * Se selecciona una foto aleatoria de la lista cada vez.
 * 
 * PLACEHOLDER TEMPORAL:
 * Por ahora todas las categorías usan un SVG placeholder.
 * 
 * Para agregar fotos reales más adelante:
 * 1. Busca fotos en Unsplash (https://unsplash.com) u otra fuente
 * 2. Copia la URL de la imagen
 * 3. Reemplaza el array de placeholder por las URLs reales
 *    Ejemplo: vegetables: ['url1', 'url2', 'url3']
 */

/**
 * Placeholder SVG en formato data URI
 * Reemplazar con URLs reales cuando tengas las fotos
 */
const PLACEHOLDER_SVG = `data:image/svg+xml,%3Csvg width='800' height='600' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3ClinearGradient id='grad' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%23f3f4f6;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%23e5e7eb;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='800' height='600' fill='url(%23grad)'/%3E%3Cg transform='translate(400,300)'%3E%3Ccircle cx='0' cy='0' r='80' fill='none' stroke='%23d1d5db' stroke-width='3' opacity='0.5'/%3E%3Cpath d='M -50 -30 L 50 -30 L 50 30 L -50 30 Z' fill='none' stroke='%23d1d5db' stroke-width='3' opacity='0.5'/%3E%3Cpath d='M -30 -50 L 30 -50 M -30 0 L 30 0 M -30 50 L 30 50' stroke='%23d1d5db' stroke-width='3' stroke-linecap='round' opacity='0.5'/%3E%3C/g%3E%3Ctext x='400' y='420' font-family='Arial, sans-serif' font-size='24' fill='%239ca3af' text-anchor='middle'%3EImagen de receta%3C/text%3E%3C/svg%3E`;

/**
 * URLs de fotos por categoría
 * TODO: Reemplazar los placeholders con URLs reales de fotos
 */
const CATEGORY_PHOTOS = {
    vegetables: [PLACEHOLDER_SVG],
    fruits: [PLACEHOLDER_SVG],
    meats: [PLACEHOLDER_SVG],
    fish: [PLACEHOLDER_SVG],
    dairy: [PLACEHOLDER_SVG],
    legumes: [PLACEHOLDER_SVG],
    cereals: [PLACEHOLDER_SVG],
    oils: [PLACEHOLDER_SVG],
    condiments: [PLACEHOLDER_SVG],
    other: [PLACEHOLDER_SVG]
};

/**
 * Obtiene una imagen aleatoria para una categoría
 * @param {string} category - Categoría de comida
 * @returns {string} URL de la imagen
 */
export const getUnsplashImageByCategory = (category = 'other') => {
    const photos = CATEGORY_PHOTOS[category] || CATEGORY_PHOTOS.other;
    // Seleccionar una foto aleatoria del array
    const randomIndex = Math.floor(Math.random() * photos.length);
    return photos[randomIndex];
};

